<template>
    <div class="message" :style="mainContentViewHeight">
        <div class="message-top">
            <p>
                <span class="title">消息中心</span> 
                （共3封，其中3封未读，<span class="never">仅查看未读消息</span>）
            </p>
            <div class="message-search">
                <el-input placeholder="请输入消息内容"></el-input>
                <el-button type="primary" size="small" @click="searchHandle">搜索</el-button>
            </div>
            <el-tabs class="message-tabs"
                v-model="tabValue"
                @tab-click="tabClick"
            >
                <el-tab-pane label="已发送" name="0"></el-tab-pane>
                <el-tab-pane label="已收到" name="1"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="table-content">
            <el-button type="primary" size="medium" disabled v-if="tabValue==='1'">标记为已读</el-button>
            <el-button type="primary" size="medium" v-if="tabValue==='1'">全部标为已读</el-button>
            <el-table
                :data="tableData"
                :row-class-name="tableRowClassName"
                stripe
                border
                style="width: 100%;margin-top:16px;"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    align="center"
                >
                </el-table-column>
                <el-table-column 
                    v-for="item in columns" 
                    :key="item.id"
                    :label="item.label"
                    :type="item.type"
                    :width="item.width"
                    :align="item.align"
                    :min-width="item.minWidth"
                    :show-overflow-tooltip="item.showOverflowTooltip"
                    :prop="item.prop"
                    :column-key="item.columnKey"
                    :sortable="item.sortable"
                    :filters="item.filters"
                >
                    <template slot-scope="scope">
                        <div v-if="item.btns" class="table-btns">
                            <el-button type="text" v-if="tabValue === '0'">删除</el-button>
                            <!-- <el-button type="text" v-if="tabValue === '1'" @click="replyHandle(scope.row)">回复</el-button>
                            <el-button type="text" @click="visible = true;">查看</el-button> -->
                        </div>
                        <span 
                            v-else 
                            :class="item.setClass && item.setClass(scope.row,item.prop)"
                        >{{item.formats?item.formats(scope.row,item.prop):scope.row[item.prop]}}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <ReplyModal ref="replyModal"></ReplyModal>
        <el-dialog
            title="消息回复"
            :visible.sync="visible"
            width="600px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            custom-class="replaymodal"
        >
            <div class="replaymodal-main">
                <!-- 如果只有一条 -->
                <div v-if="false">
                    <p class="replaymodal-main--row">
                        <span class="row-title">回复方：</span>
                        <span class="row-content">张三</span>
                    </p>
                    <p class="replaymodal-main--row">
                        <span class="row-title">回复时间：</span>
                        <span class="row-content">2023-01-15 15:00:00</span>
                    </p>
                    <p class="replaymodal-main--row">
                        <span class="row-title">回复内容：</span>
                        <span class="row-content">处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中</span>
                    </p>
                </div>
                <!-- 多条数据 -->
                <div v-if="true">
                    <div class="replaymodal-main--item" v-for="i in 4" :key="i">
                        <div class="replaymodal-item--index">
                            <div class="index-circle">{{i}}</div>
                        </div>
                        <div class="replaymodal-item--content">
                            <p class="replaymodal-main--row">
                                <span class="row-title">回复方：</span>
                                <span class="row-content">张三</span>
                            </p>
                            <p class="replaymodal-main--row">
                                <span class="row-title">回复时间：</span>
                                <span class="row-content">2023-01-15 15:00:00</span>
                            </p>
                            <p class="replaymodal-main--row">
                                <span class="row-title">回复内容：</span>
                                <span class="row-content">处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中处理中</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns">
                <el-button size="medium" @click="visible = false;">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ReplyModal from '@/components/ReplyModal';
let columns = [
    {id:20,label:'发送状态',width: '120px',align:'center',setClass:(row,prop) => {console.log(row)}},
    // {id:3,label:'消息类型',minWidth: '250px',showOverflowTooltip: true,prop: 'field3'},
    {id:40,label:'发送人',minWidth: '120px',prop: 'sendUser',align:'center'},
    {id:50,label:'消息内容',minWidth: '140px',prop: 'content',align:'center'},
    {id:60,label:'发送时间',minWidth: '140px',showOverflowTooltip: true,prop: 'sendTime',align:'center'},
    // {id:7,label:'回复状态',minWidth: '140px',showOverflowTooltip: true,prop: 'address',align:'center'},
    {id:80,label:'操作',width: '120px',align:'center',btns: true},
]
import {apiBasicMsglogList} from '@/server/msg.js';
export default {
    props: ['mainContentViewHeight'],
    components: {
        ReplyModal
    },
    data() {
        return {
            tabValue: '0',
            tableData: [],
            columns: columns,
            visible: false,
            dataForm: {
                content: ''
            }
        }
    },
    computed: {
        userinfo: {
            get () {
                return this.$store.state.user.userinfo
            }
        }
    },
    mounted() {
        this.apiBasicMsglogList();
    },
    methods: {
        apiBasicMsglogList() { //获取数据
            apiBasicMsglogList({
                filter: {
                    receiveUserId: this.userinfo.userId,
                    searchContent: this.dataForm.content || null
                }
            }).then(({data}) => {
                this.tableData = data.rows || [];
            })
        },
        searchHandle() {
            this.apiBasicMsglogList();
        },
        tableRowClassName({row}) {
            if (row.status === '1') {
                return 'unread-row';
            }
            return '';
        },
        tabClick() { //tabs点击切换
            this.columns.map(item => {
                if(item.id === 20) {
                    if(this.tabValue === '0') {
                        item.label = '发送状态';
                    }
                    if(this.tabValue === '1') {
                        item.label = '接收状态';
                    }
                }
            })
        },
        replyHandle(row) {
            this.$refs.replyModal.open(row);
        }
    }
}
</script>

<style lang="less" scoped>
.message {
    .message-top {
        background: #fff;
        padding: 30px 40px 0 24px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        >p {
            .title {
                font-size: 18px;
                font-weight: 700;
            }
            .never {
                color: @--color-primary;
                cursor: pointer;
                &:hover {
                    opacity: .8;
                }
            }
        }
        .message-search {
            display: flex;
            justify-content: center;
            align-items: center;
            .el-input {
                width: 350px;
            }
        }
        .message-tabs {
            margin: 30px 0 0 20px;
            /deep/ .el-tabs__header {
                margin: 0;
                .el-tabs__nav-wrap::after {
                    display: none;
                }
                .el-tabs__item {
                    width: 100px;
                    text-align: center;
                }
            }
        }
    }
    .table-content {
        background-color: #fff;
        margin-top:24px;
        padding: 16px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        /deep/ .unread-row {
            td{
                color: @--color-primary;
            }
        }
    }
    /deep/ .replaymodal {
        .el-dialog__body {
        }
        .replaymodal-main {
            max-height: 400px;
            overflow: auto;
            .replaymodal-main--row {
                display: flex;
                align-content: flex-start;
                span {
                    display: inline-block;
                    &.row-title {
                        font-weight: bold;
                        width: 100px;
                        text-align: right;
                    }
                    &.row-content {
                        width: calc(100% - 100px);
                    }
                }
            }
            .replaymodal-main--item {
                display: flex;
                .replaymodal-item--index {
                    // width: 40px;
                    position: relative;
                    .index-circle {
                        width: 22px;
                        height: 22px;
                        line-height: 20px;
                        border-radius: 50%;
                        background-color: #F59A23;
                        color: #ffffff;
                        font-weight: bold;
                        text-align: center;
                        border: 1px solid #ffffff;
                        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.3);
                    }
                    &:after {
                        content: '';
                        width: 1px;
                        height: 100%;
                        // background-color: #E8E8E8;
                        background: linear-gradient(
                            to bottom,
                            transparent 0%,
                            transparent 50%,
                            #ccc 50%,
                            #ccc 100%
                        );
                        background-size: 1px 10px;
                        background-repeat: repeat-y;
                        position: absolute;
                        top: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
                &:last-child :after {
                    display: none;
                }
                .replaymodal-item--content {
                    width: calc(100% - 40px);
                }
            }
        }
        .btns {
            margin-top: 40px;
            text-align: center;
        }
    }
}
</style>